<template>
  <a-popover placement="topRight" ref="popover">
    <template slot="content">
      <p>{{ helpMessage }}</p>
    </template>
    <div class="item" @click.stop="selectAttribute">
      <a-row>
        <a-col span="20">
                    <span class="key">
                        {{'{' + definition.prefix + '_' + value.key + '}'}}
                    </span>
          {{ value.name }}
        </a-col>
        <a-col span="4" style="text-align: right">
          <a-button :key="value.id" shape="circle"
                    type="primary"
                    icon="plus"></a-button>
        </a-col>
      </a-row>
    </div>
  </a-popover>
</template>

<script>
import {mapGetters} from "vuex";
import store from '../store';

export default {
  name: "ValueComponent",
  props: {
    value: Object,
    definition: Object,
    helpMessage: {
      type: String,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      name: '$_dashboard/name',
    }),
    fullPrefix: function () {
      return this.definition.prefix + '_' + this.value.key;
    },
  },
  created() {
    const STORE_KEY = '$_dashboard';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  mounted() {
    if (!this.helpMessage) {
      this.$refs.popover.visible = false
    }
  },
  methods: {
    getRelationKey(definition, key = []) {
      if (this.exists(definition.relationKey)) {
        key.push(definition.relationKey);
      }

      if (this.exists(definition.parentDefinition)) {
        key = this.getRelationKey(definition.parentDefinition, key);
      }

      return key;
    },
    selectAttribute() {
      let relationKeyArray = this.getRelationKey(this.definition).reverse();
      let key = '';

      if (relationKeyArray.length > 0) {
        key = relationKeyArray.join('.');
        key += '.' + this.value.key_with_prefix
      } else {
        key = this.value.key_with_prefix;
      }

      this.$emit('selectAttribute', {
        key: key,
        name: this.value.name,
      });
    },
    exists(load) {
      if (load !== undefined && load !== null) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.item {
  border: solid 1px #ccc;
  border-radius: 3px;
  margin: .5rem;
  padding: 1rem 1.5rem;
  clear: both;
  background: white;
}

.item .key {
  background: #839aaf;
  border-radius: 2px;
  padding: .5rem;
  color: white;
  font-family: monospace;
  font-weight: 500;
  display: inline-block;
  font-size: 12px;
}
</style>